import React from "react";

import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { queryClient } from "../lib/queryClient";

interface QueryProviderProps {
  children: React.ReactNode;
  enableDevtools?: boolean;
}

/**
 * Provider component that sets up React Query.
 * This should be used to wrap your app when using React Query.
 */
export function QueryProvider({
  children,
  enableDevtools = process.env.NODE_ENV === "development",
}: QueryProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {enableDevtools && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
